'use strict';

/* jshint -W098 */
angular.module('mean.system-bids').controller('ModalRemoveTradeController', ['$scope', 'Global', '$uibModalInstance', 'trade', 'selectedBid', 'toaster',
  function($scope, Global, $uibModalInstance, trade, selectedBid, toaster) {
    $scope.global = Global;
    $scope.package = {
      name: 'system-bids'
    };

    console.log('ModalRemoveTradeController');

    $scope.trade = trade;
    $scope.selectedBid = selectedBid;

    $scope.updateDates = function(item) {
        if(item.date_received)
            item.date_received = new Date(item.date_received);
        if(item.date_requested)
            item.date_requested = new Date(item.date_requested);
        if(item.date_declined)
            item.date_declined = new Date(item.date_declined);
        if(item.date_rejected)
            item.date_rejected = new Date(item.date_rejected);
        if(item.date_accepted)
            item.date_accepted = new Date(item.date_accepted);
        if(item.date_completed)
            item.date_completed = new Date(item.date_completed);
    };

    $scope.removeDates = function(item) {
        if(!item.date_received || item.date_received == 'Invalid Date')
            delete item.date_received;
        if(!item.date_requested || item.date_requested == 'Invalid Date')
            delete item.date_requested;
        if(!item.date_declined || item.date_declined == 'Invalid Date')
            delete item.date_declined;
        if(!item.date_rejected || item.date_rejected == 'Invalid Date')
            delete item.date_rejected;
        if(!item.date_accepted || item.date_accepted == 'Invalid Date')
            delete item.date_accepted;
        if(!item.date_completed || item.date_completed == 'Invalid Date')
            delete item.date_completed;
    };

    $scope.ok = function () {
        $uibModalInstance.close($scope.selected.item);
    };

    $scope.removeBidTrade = function() {
        var idx = -1;
        _.each($scope.selectedBid.bidding_trades, function(trade, ii) {
            if($scope.trade._id === trade._id) {
                idx = ii;
            }
        });

        if(idx !== -1) {
            $scope.trade.$delete(function(success) {
                $scope.selectedBid.bidding_trades.splice(idx, 1);
                $scope.selectedBid.$update(function(success) {
                    $scope.selectedBid = success;
                    $uibModalInstance.close();
                    toaster.pop('success', 'Trade Removed');
                }, function(error) {
                    toaster.pop('error', 'Trade Removal from Bid Error', error);
                });
            }, function(error) {
                toaster.pop('error', 'Trade Removal Error', error);
            });
        } else {
            toaster.pop('error', 'Trade Retrieval', 'Problem getting the trade');
        }
        $scope.trade = {};
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/system-bids/public/controllers/modal-remove-trade-controller.js